import { render, staticRenderFns } from "./layout.md?vue&type=template&id=2760152c&"
import script from "./layout.md?vue&type=script&lang=js&"
export * from "./layout.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2760152c')) {
      api.createRecord('2760152c', component.options)
    } else {
      api.reload('2760152c', component.options)
    }
    module.hot.accept("./layout.md?vue&type=template&id=2760152c&", function () {
      api.rerender('2760152c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/plugin/legend/layout.md"
export default component.exports